import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EditServiceLayer from "../components/EditServiceLayer";

const AddServicePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Service Edit' />

        {/* AddBlogLayer */}
        <EditServiceLayer />
      </MasterLayout>
    </>
  );
};

export default AddServicePage;
